import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { HeaderService } from '../../../../core/services/header.service';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-storage-main-panel',
  templateUrl: './storage-main-panel.component.html',
  styleUrls: ['./storage-main-panel.component.scss'],
})
export class StorageMainPanelComponent implements OnInit {
  storage: Storage;
  activeStorage: string;
  selectedIndex: number;
  lastRefreshedTime: Date; // time when data is loaded/refreshed
  depName: string;
  cloudType: string;
  
  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private navService: NavigationService,
    private headerService: HeaderService,
  ) {  }

  ngOnInit(): void {
    this.cloudType = this.route.snapshot.params['cloudType'] || this.route.parent.snapshot.params['cloudType']
    this.navService.sendCloud(this.cloudType)
    this.navService.subNavData(Entities.Storages);
    this.activeStorage = this.route.snapshot.params['storageName'];
    this.depName = this.route.snapshot.params['deploymentName'];
    this.navService.sendDeploymentName(this.depName);
    this.navService.sendLeftPanelIndex(0);
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
  }

  activateClass(index: number) {
    this.selectedIndex = index;
  }

  refreshComponent() {
    let url = this._router.url;
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate([decodeURI(url)]);
    });
  }
}
